export default function Specs() {
  const specs = [
    { k: "MPS Part No.", v: "MWP1110" },
    { k: "OE Reference", v: "04L 121 011" },
    { k: "Pump Type", v: "Switchable Coolant Pump" },
    { k: "Actuation", v: "Flexible-impeller hydraulic" },
    { k: "Failure Mode", v: "Locked Open" },
    { k: "Inlet Filter", v: "Integrated" },
    { k: "Return Spring", v: "Reinforced gauge" },
    { k: "Outer Diameter", v: "74.4 mm" },
    { k: "Total Length", v: "98.0 mm" },
    { k: "Impeller OD", v: "70.3 mm" },
    { k: "Design Origin", v: "MPS Proprietary" },
    { k: "Fitments", v: "VW · Audi · Škoda · SEAT · Cupra" },
  ];

  return (
    <section
      id="specs"
      data-testid="specs-section"
      className="relative py-28 lg:py-36 bg-white overflow-hidden"
    >
      <div className="absolute inset-0 tech-grid opacity-25 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          {/* Render */}
          <div className="lg:col-span-6 relative reveal">
            <div className="relative">
              {/* corner brackets */}
              <div className="absolute -inset-3 pointer-events-none">
                <div className="absolute top-0 left-0 w-5 h-5 border-t border-l border-[#5B9BD5]" />
                <div className="absolute top-0 right-0 w-5 h-5 border-t border-r border-[#5B9BD5]" />
                <div className="absolute bottom-0 left-0 w-5 h-5 border-b border-l border-[#5B9BD5]" />
                <div className="absolute bottom-0 right-0 w-5 h-5 border-b border-r border-[#5B9BD5]" />
              </div>
              <img
                src="/assets/ewp1110_render4.png"
                alt="MWP1110 product render — high-detail studio shot"
                className="relative w-full object-contain"
              />
            </div>
            <div className="mt-6 flex items-center justify-center gap-3 font-mono text-[10px] tracking-[0.3em] text-[#8896A6] uppercase">
              MPS-MWP1110 · STUDIO RENDER
            </div>
          </div>

          {/* Specs grid */}
          <div className="lg:col-span-6 reveal">
            <span className="spec-label">MWP1110 Technical Datasheet</span>
            <h2 className="font-chivo font-black text-4xl sm:text-5xl tracking-tighter text-[#1A2232] mt-5 leading-[0.95]">
              MWP1110 specifications —<br />
              <span className="text-[#5B9BD5]">technical data.</span>
            </h2>

            <div className="mt-10 border-t border-[#C8D3DF]">
              {specs.map((s, i) => (
                <div
                  key={s.k}
                  className="grid grid-cols-2 py-4 border-b border-[#E8EEF6] hover:bg-white transition-colors"
                  data-testid={`spec-row-${i}`}
                >
                  <span className="font-mono text-[11px] tracking-[0.18em] text-[#8896A6] uppercase">
                    {s.k}
                  </span>
                  <span className="font-chivo font-bold text-[#1A2232] text-sm text-right">
                    {s.v}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
